import { useEffect, useState } from 'react';

const SMALL_VIEWPORT_QUERY = '(max-width: 639.98px)';

/**
 * Returns true on viewports below Tailwind's `sm` breakpoint (640px).
 *
 * SSR-safe: returns false on first paint (matching useIsMobile's convention),
 * then updates after mount via a matchMedia subscription.
 *
 * Distinct from useIsMobile (1024 + touch + iPad-forced) — that hook drives
 * navigation/hamburger decisions on a broader "mobile" definition. This hook
 * is for the narrower sub-sm question: "should we render a component built
 * specifically for the <640px viewport class?" — e.g., MLBBetaPlayersMobile.
 */
export function useIsSmallViewport(): boolean {
  const [matches, setMatches] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(SMALL_VIEWPORT_QUERY);
    const update = () => setMatches(mq.matches);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);

  return !!matches;
}
